import React, { useEffect, useState } from "react";
import { db } from "../firebase"; // Ensure firebase is properly initialized
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios"; // Import axios for API calls

const Community = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Add a state to store location info
  const [locations, setLocations] = useState({});

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        // Query to fetch all users who have the 'approval' field
        const q = query(collection(db, "users"), where("approval", "!=", null));
        const querySnapshot = await getDocs(q);
        const usersData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        console.log(usersData);
        setUsers(usersData);
      } catch (error) {
        console.error("Error fetching users: ", error);
      }
    };

    fetchUsers();
  }, []);

  // Function to get city and country name from latitude and longitude
  const getLocationInfo = async (latitude, longitude) => {
    const apiKey = "3f26e165592a4841b222257e6d8e7614"; // Replace with your OpenCage API key
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    try {
      const response = await axios.get(url);
      const { results } = response.data;
      if (results.length > 0) {
        const city = results[0].components.city || results[0].components.county || results[0].components.village;
        //const county = results[0].components.county;
        const country = results[0].components.country;
        const state = results[0].components.state;
        console.log(response)
        return `${city},   ${state},  ${country}`;
      }
    } catch (error) {
      console.error("Error fetching location info: ", error);
      return "Unknown Location";
    }
  };

  useEffect(() => {
    // Fetch the location info when users change
    const fetchLocationInfo = async () => {
      const newLocations = {};
      for (const user of users) {
        if (user.current_location) {
          const location = await getLocationInfo(user.current_location.latitude, user.current_location.longitude);
          newLocations[user.id] = location;
        }
      }
      setLocations(newLocations);
    };

    fetchLocationInfo();
  }, [users]);

  const handleApprove = async (userId, currentApproval) => {
    try {
      const userDoc = doc(db, "users", userId);
      await updateDoc(userDoc, { approval: !currentApproval });
      setUsers(prevUsers => prevUsers.map(user =>
        user.id === userId ? { ...user, approval: !currentApproval } : user
      ));
    } catch (error) {
      console.error("Error updating approval status: ", error);
    }
  };

  const handleModalConfirm = () => {
    if (selectedUser) {
      handleApprove(selectedUser.id, selectedUser.approval);
      setShowModal(false);
      setSelectedUser(null);
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <div>
      <h1>Community Approval</h1>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>DOB</th>
            <th>ID Card</th>
            <th>Selfie</th>
            
            <th>Current Location</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.DOB}</td>
              <td><img src={user.ID_card} alt="ID Card" style={{ width: "100px" }} /></td>
              <td><img src={user.selfie} alt="Selfie" style={{ width: "100px" }} /></td>

              <td>
                {user.current_location ? (
                  <>
                    <MapContainer 
                      center={[user.current_location.latitude, user.current_location.longitude]} 
                      zoom={13} 
                      style={{ width: "150px", height: "100px" }}>
                      <TileLayer 
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <Marker position={[user.current_location.latitude, user.current_location.longitude]}>
                        <Popup>{user.name}'s Location</Popup>
                      </Marker>
                    </MapContainer>
                    <p>
                      <strong>Location:</strong> 
                      {locations[user.id] || "Loading..."}
                    </p>
                  </>
                ) : (
                  <p>No location</p>
                )}
              </td>
              <td>
                <button
                  onClick={() => { setSelectedUser(user); setShowModal(true); }}
                  style={{ backgroundColor: user.approval ? "red" : "green", color: "white" }}
                >
                  {user.approval ? "Disapprove" : "Approve"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && selectedUser && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h3>Are you sure you want to {selectedUser.approval ? "disapprove" : "approve"} {selectedUser.name}?</h3>
            <div style={modalActionsStyle}>
              <button onClick={handleModalConfirm} style={buttonStyle}>Yes</button>
              <button onClick={handleModalCancel} style={buttonStyle}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// CSS styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "300px",
  textAlign: "center",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const modalActionsStyle = {
  marginTop: "20px",
  display: "flex",
  justifyContent: "space-around",
};

const buttonStyle = {
  padding: "10px 20px",
  cursor: "pointer",
};

export default Community;
